export default __webpack_public_path__ + "images/0x9bd9ad490dd3a52f096d229af4483b94d63be618.png";